import { Skeleton } from '@mui/material';
import React, { useEffect, useState } from 'react';
export function useAudioContext() {
    const context = React.useContext(AudioContextContext);
    if (context == null) {
        throw new Error('No audio context');
    }
    return context.audioContext;
}
export const AudioContextContext = React.createContext(null);
export function AudioContextProvider(props) {
    const { children } = props;
    const [audioContext, setAudioContext] = useState();
    useEffect(() => {
        const context = createAudioContext({ latencyHint: 'interactive' });
        if (context == null) {
            throw new Error('Cannot create AudioContext');
        }
        context.suspend();
        setAudioContext(context);
        return () => {
            context.suspend();
            if (context.state != 'closed')
                context.close();
        };
    }, []);
    if (audioContext == null) {
        return React.createElement(Skeleton, { variant: "rectangular", width: "100%", height: "100%", animation: 'pulse', sx: { minHeight: '100px', minWidth: '100px' } });
    }
    return React.createElement(AudioContextContext.Provider, { value: { audioContext } }, children);
}
function createAudioContext(options) {
    if (typeof window === 'undefined') {
        return null;
    }
    const Context = window.AudioContext || window.webkitAudioContext;
    if (!Context)
        return null;
    try {
        return new Context(options);
    }
    catch (err) {
        return new Context();
    }
}
//# sourceMappingURL=AudioContextContext.js.map